import React, { useState } from 'react';
import UserContext from './UserContext';
import useEventBus from "../../../eventBus/useEventBus";
import useIsBot from "../../../common/hooks/useIsBot";
import { signOut, getConsumerId, getIdToken, publishFetchProfileData } from './utils/userProviderUtils';
export default ({
  children
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [isUserInfoReady, setIsUserInfoReady] = useState(false);
  const [profileDataSuccessCompleted, setProfileDataSuccessCompleted] = useState(false);
  const [errorFetchingData, setErrorFetchingData] = useState(false);
  const isBot = useIsBot();
  useEventBus('userProfile.authData', ({
    isLoggedIn,
    email,
    authProviderName,
    authProviderCode,
    consumerId
  }) => {
    setErrorFetchingData(false);
    setIsLoggedIn(isLoggedIn);
    setUserInfo({
      email,
      authProviderName,
      authProviderCode,
      consumerId
    });
    if (isLoggedIn) {
      publishFetchProfileData();
    }
    setIsUserInfoReady(true);
  });
  useEventBus('userProfile.profileDataSuccess', data => {
    setErrorFetchingData(false);
    setUserInfo({
      ...userInfo,
      ...data
    });
    setProfileDataSuccessCompleted(true);
  });
  useEventBus('auth.signout', () => {
    setErrorFetchingData(false);
    setIsLoggedIn(false);
    setUserInfo(null);
    setProfileDataSuccessCompleted(false);
  });
  useEventBus('userProfile.error', () => {
    if (!isBot) {
      setErrorFetchingData(true);
      setIsLoggedIn(false);
      setIsUserInfoReady(true);
    }
  });
  return React.createElement(React.Fragment, null, React.createElement(UserContext.Provider, {
    value: {
      isLoggedIn,
      isUserInfoReady,
      setIsLoggedin: setIsLoggedIn,
      signOut,
      userInfo,
      getIdToken,
      getConsumerId,
      setUserInfo,
      errorFetchingData,
      profileDataSuccessCompleted,
      setProfileDataSuccessCompleted
    }
  }, children));
};